import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { ChevronsLeftIcon, ChevronsRightIcon, XIcon } from "lucide-react";
import { useContext } from "react";

import { cn } from "@/shared/lib";

import { Button } from "../button";
import { SheetClose } from "../sheet";
import { Tooltip, TooltipContent, TooltipTrigger } from "../tooltip";
import { SidebarDrawerContext } from "./SidebarDrawerContext";
import { useSidebar } from "./useSidebar";

const CLASSES = cn("size-11 bg-transparent text-muted hover:text-foreground [&_svg]:size-5");

// Кнопка в шапке меню: на компьютере сворачивает и разворачивает его, в шторке закрывает.
export const SidebarToggle = ({ className }: { className?: string }) => {
  const { _ } = useLingui();
  const inDrawer = useContext(SidebarDrawerContext);
  const { state, toggle } = useSidebar();

  if (inDrawer) {
    return (
      <SheetClose asChild>
        <Button
          variant="outline"
          size="icon"
          aria-label={_(msg`Close menu`)}
          className={cn(CLASSES, className)}
        >
          <XIcon aria-hidden="true" />
        </Button>
      </SheetClose>
    );
  }

  const collapsed = state === "collapsed";
  const label = collapsed ? _(msg`Expand menu`) : _(msg`Collapse menu`);
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          aria-label={label}
          aria-expanded={!collapsed}
          className={cn(CLASSES, className)}
          onClick={toggle}
        >
          {collapsed ? (
            <ChevronsRightIcon aria-hidden="true" />
          ) : (
            <ChevronsLeftIcon aria-hidden="true" />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent side="right">{label}</TooltipContent>
    </Tooltip>
  );
};
